/**
 * 059「EOS與EOL統計」三桶的 mock 計算(模擬後端 GetAssetRiskSummary,不是前端自己湊)。
 *
 * 後端 swagger:「未填視為無過期」「三項加總等於 TotalAssetCount」。所以日期缺鍵、null、空字串
 * 都算「沒過期」—— 每筆資產一定落在其中一桶。抽成獨立模組是為了能直接測這些邊界
 * (mock 種子裡沒有缺鍵的資料,透過 API 測不到;/code-review 抓到過缺鍵時算成 NaN 漏掉一筆)。
 */

/** 一律回 boolean。缺值算沒過期。 */
export const isPastDate = (d, now = new Date()) => Boolean(d) && new Date(d) < now;

/** [eos, eol] 日期對 → 三個互斥桶(過期數 2／1／0) */
export function eosEolBuckets(pairs, now = new Date()) {
  const expired = pairs.map(([eos, eol]) => Number(isPastDate(eos, now)) + Number(isPastDate(eol, now)));
  return {
    eos_eol_both_expired_count: expired.filter((n) => n === 2).length,
    eos_eol_one_expired_count: expired.filter((n) => n === 1).length,
    eos_eol_none_expired_count: expired.filter((n) => n === 0).length,
  };
}
